// extracted by mini-css-extract-plugin
module.exports = {"container":"Bubbles1_container__2FX1S","bubble1":"Bubbles1_bubble1__3ZP2P","bubble2":"Bubbles1_bubble2__32xWX"};